import { createApp } from 'vue'
import App from './App.vue'
import "./assets/global.css"

createApp(App).mount('#app')
